import { render, staticRenderFns } from "./MarketScroll.vue?vue&type=template&id=020d7be8&scoped=true&"
import script from "./MarketScroll.vue?vue&type=script&lang=js&"
export * from "./MarketScroll.vue?vue&type=script&lang=js&"
import style0 from "./MarketScroll.vue?vue&type=style&index=0&id=020d7be8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020d7be8",
  null
  
)

export default component.exports